module.exports = __webpack_public_path__ + "assets/categories_button-fed557.svg";